import Headroom from "headroom.js"
import { throttle } from "lodash"

function reskinHeader(header) {
	if ((window.scrollY || document.documentElement.scrollTop)
        < header.getBoundingClientRect().height) {
		header.classList.add("header--hero")
	} else {
		header.classList.remove("header--hero")
	}
}
// Initialise headroom
const header = document.querySelector(".header")
if (window.location.pathname === "/") {
	header.classList.add("header--hero")
}
const headroom = new Headroom(header, {
	offset: 100,
	onPin() {
		document.body.classList.add("hr--pinned")
		document.body.classList.remove("hr--unpinned")
	},
	onUnpin() {
		document.body.classList.add("hr--unpinned")
		document.body.classList.remove("hr--pinned")
	},
})
headroom.init()
// Do the header style transition thing
const hero = document.querySelector(".js-hero")
if (hero) window.addEventListener("scroll", throttle(() => reskinHeader(header), 100))